/** Namespace `reliability` — bản gốc tiếng Việt. Khoá phẳng, tên camelCase; `{biến}` để chèn. */
export const reliability = {
  title: "Độ tin cậy",
  subtitle:
    "Dịch vụ và tài nguyên đo riêng — một API chết trong khi cơ sở dữ liệu còn sống là hai tin khác nhau.",
  loadFailed: "Không đọc được số liệu độ tin cậy.",
  loadingServices: "Đang đọc dịch vụ…",
  noServicesTitle: "Danh mục chưa có dịch vụ nào.",
  noServicesBefore: "Chạy ",
  noServicesAfter: " để nạp danh mục từ mã nguồn.",
  services: "Dịch vụ",
  "col.service": "Dịch vụ",
  "col.type": "Loại",
  "col.tier": "Mức",
  "col.liveness": "Sống",
  "col.latency": "Độ trễ",
  "col.owner": "Chủ sở hữu",
  "col.sampledAt": "Đo lúc",
  "col.version": "Phiên bản",
  "col.url": "URL",
  "build.undeclared": "Chưa khai",
  "summary": "{up} sống · {down} không trả lời · {unmeasured} chưa đo — trên {total} dịch vụ",
  "sampleHttp": "HTTP",
  "sampleVersion": "bản",
  hasOwner: "Đã có",
  noOwner: "Chưa có chủ",
  "live.notMeasured": "Không đo",
  "live.notProbed": "Chưa probe",
  "live.up": "Sống",
  "live.down": "Không trả lời",
  loadingResources: "Đang đọc tài nguyên…",
  noResources: "Chưa có tài nguyên nào — worker khai chúng lúc khởi động, seed danh mục bổ sung phần còn lại.",
  resources: "Tài nguyên",
  "col.resource": "Tài nguyên",
  "col.size": "Dung lượng",

  loadDetailFailed: "Không đọc được chi tiết dịch vụ.",
  noOwnerAssign: "Chưa có chủ — gán ngay",
  blastRadius: "Hỏng nó thì hỏng những gì",
  noDependentsBefore: "Không dịch vụ nào khai phụ thuộc vào nó. ",
  noDependentsStrong: "Chưa khai",
  noDependentsAfter: " khác với « độc lập » — danh mục nạp từ mã nguồn.",
  needs: "Nó cần gì để chạy",
  noNeeds: "Chưa khai phụ thuộc hay tài nguyên nào.",
  healthTitle: "Sức khoẻ — 50 mẫu gần nhất",
  noHealthBefore: "Chưa probe lần nào. Dịch vụ không khai ",
  noHealthMiddle: " thì hub không đo — và trường đó ",
  noHealthStrong: "chỉ sửa được trong mã nguồn",
  noHealthAfter: ", vì worker sẽ gọi địa chỉ ấy.",
  sampleUp: "sống",
  sampleDown: "không trả lời",
  healthLegendBefore: "Mới nhất bên trái. Xen kẽ đỏ-xanh nghĩa là ",
  healthLegendStrong: "chập chờn",
  healthLegendAfter: " — vấn đề khác hẳn một dải đỏ liền, và cần cách sửa khác.",
  externalLinks: "Đường dẫn ngoài",
  sourceCode: "Mã nguồn:",
} as const;
